import React from 'react';
import googleplay from '../../assets/images/google-play.svg';
import appstore from '../../assets/images/app-store.svg';
import ga4Events from '../../ga4Events';

const DownloadBlock = ({ section = 'unknown' }) => {
  return (
    <div className="btn_block">
      <ul className="app_btn button_group">
        <li>
          <a
            className="button_group_item"
            target="_blank"
            rel="noopener noreferrer"
            href="https://play.google.com/store/apps/details?id=com.softupper.fairytailer"
            onClick={() => ga4Events.download.android_download_button_clicked(section)}
          >
            <img className="download_img" src={googleplay} alt="image" />
          </a>
        </li>
        <li>
          <a
            className="button_group_item"
            target="_blank"
            rel="noopener noreferrer"
            href="https://apps.apple.com/by/app/fairytaler-bedtime-ai-stories/id6476602417"
            onClick={() => ga4Events.download.ios_download_button_clicked(section)}
          >
            <img className="download_img" src={appstore} alt="image" />
          </a>
        </li>
      </ul>
    </div>
  );
};

export default DownloadBlock;
